import React from 'react'
import { NoveltyPlacePillStyled, NoveltyPlaceTextStyled } from './Common.styles'

interface PlaceTextStyledProps {
  displayPill: boolean
  text?: string
  abbrStyled?: React.ReactNode
}

export const PlaceTextStyled = ({ displayPill, text, abbrStyled }: PlaceTextStyledProps) => {
  if (displayPill) {
    return (
      <NoveltyPlacePillStyled>
        {abbrStyled}
        {text}
      </NoveltyPlacePillStyled>
    )
  } else {
    return (
      <NoveltyPlaceTextStyled>
        {abbrStyled}
        {text}
      </NoveltyPlaceTextStyled>
    )
  }
}
